<template>
    <v-container fluid class="user-list" v-if="languageData.calculationWorkCosts">
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position">
            <v-layout align-center pr-4>
                <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
                <v-layout column>
                <div>
                    <strong>{{ snackbar.title }}</strong>
                </div>
                <div>{{ snackbar.text }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
        <v-row class="ma-0 mb-8">
            <v-card width="100%" elevation="0">
                <v-row no-gutters justify="end" width="100%">
                    <div>
                        <v-btn height="55px" width="100%" class="search-button" color="primary" @click="openWorkCostFormModal">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            {{ languageData.calculationWorkCosts.addWorkCostBtn }}
                        </v-btn>
                    </div>  
                </v-row>
            </v-card>
        </v-row>
        <v-row class="ma-0">
      <v-card width="100%" class="ma-1" elevation="0">
        <v-card-text>
          <v-data-table
            :headers="calculationWorkCostsTableHeaders"
            :items="workCostsData"
        >
            <template v-slot:item.price="{ item }">
                <span>
                {{ item.price + '€' }}
                </span>
            </template>
            <template v-slot:item.total="{ item }">
                <span>
                {{ item.total + '€'  }}
                </span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="editWorkCost(item)"
                        icon>
                        <v-icon color="fontDefault">edit</v-icon>
                    </v-btn>
                    </template>
                    <span>{{ languageData.calculationWorkCosts.edit }}</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="showDeleteWorkCostModal(item)">
                        <v-icon color="fontDefault">delete</v-icon>
                    </v-btn>
                    </template>
                    <span>{{ languageData.calculationWorkCosts.delete }}</span>
                </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <ModalInfo layout="modalSelectTable" v-if="isShowWorkCostForm" :hidden-agree-btn="true" @clicked="hideWorkCostForm" :show-modal="isShowWorkCostForm">
      <template v-slot:body>
        <WorkCostForm :layout="workCostFormlayout" :workCostData="activeWorkCost"></WorkCostForm>
      </template>
    </ModalInfo>
    <ModalInfo @doOperation="deleteWorkCost" :isLoadingBtn="false" :headModal="deleteWorkCostModal.head" :btnDisAgreeText="languageData.calculationWorkCosts.btnDisAgreeDeleteWorkCostText" :btnAgreeText="languageData.calculationWorkCosts.btnAgreeDeleteWorkCostText" :visDisAgreeBtn="true" @clicked="hideDeleteWorkCostModal" :show-modal="deleteWorkCostModal.isVisible" :text-modal="deleteWorkCostModal.textInfo"></ModalInfo>
    </v-container>
</template>

<script>
import ModalInfo from "../../../../../components/ModalInfo/ModalInfo.vue";
import {mapState} from "vuex";
import eventBus from "../../../../../event-bus/eventBus";
import WorkCostForm from "../WorkCostForm/WorkCostForm.vue";
export default {
    name: "WorkCostsTable",
    components: {ModalInfo, WorkCostForm},
    props: {
      workCostsData: Array,
      workCostsDeleted: Array,
      calculationItemId: Number,
    },
    data() {
        return {
            isShowWorkCostForm: false,
            activeWorkCost: null,
            workCostFormlayout: null,
            deleteWorkCostModal: {
                isVisible: false,
                head: null,
                textInfo: null
            },
            snackbar: {
                color: null,
                icon: null,
                mode: null,
                position: null,
                text: null,
                corner: null,
                timeout: 7500,
                title: null,
                visible: false
            },
        }
    },
    computed: {
        ...mapState("getCalculations", {
            calculationWorkCostsTableHeaders: state => state.calculationWorkCostsTableHeaders
        }),
    },
    methods: {
        openWorkCostFormModal() {
            this.workCostFormlayout = 'add';
            this.isShowWorkCostForm = true;
        },

        hideWorkCostForm() {
            this.isShowWorkCostForm = false;
        },

        editWorkCost(workCost) {
            this.workCostFormlayout = 'edit';
            this.activeWorkCost = workCost;
            this.isShowWorkCostForm = true;
        },

        showDeleteWorkCostModal(workCost) {
            this.activeWorkCost = workCost
            this.deleteWorkCostModal.head = this.languageData.calculationWorkCosts.deleteWorkCostHead;
            this.deleteWorkCostModal.textInfo = this.languageData.calculationWorkCosts.deleteWorkCostTextInfo;    
            this.deleteWorkCostModal.isVisible = true;
        },

        deleteWorkCost() {
            if(this.activeWorkCost.id) {
                this.workCostsDeleted.push(this.activeWorkCost.id);
            }
            this.workCostsData.splice(this.workCostsData.indexOf(this.activeWorkCost), 1);
            this.activeWorkCost = null;    
            this.getSnackbarSuccess(this.languageData.calculationWorkCosts.deleteWorkCostSuccessHead, this.languageData.calculationWorkCosts.deleteWorkCostSuccessTextInfo);
        },

        hideDeleteWorkCostModal() {
            this.deleteWorkCostModal.isVisible = false;
        },

        getSnackbarSuccess: function(title, message, top = true) {
            this.snackbar = {
                color: "success",
                icon: "check_circle",
                mode: "multi-line",
                position: top,
                timeout: 7500,
                corner: 'right',
                title: title,
                text: message,
                visible: true
            };
        },
    },
    mounted() {
        eventBus.$on('addNewWorkCost', (workCost) => {
            this.workCostsData.push(workCost);
            this.hideWorkCostForm();
            this.getSnackbarSuccess(this.languageData.calculationWorkCosts.addNewWorkCostHead, this.languageData.calculationWorkCosts.addNewWorkCostTextInfo);
        })

        eventBus.$on('updateWorkCost', (updatedWorkCost) => {
            const workCost = this.workCostsData.find(el => el.id === updatedWorkCost.id);
            workCost.price = Number(updatedWorkCost.price);
            workCost.quantity = Number(updatedWorkCost.quantity);
            workCost.total = Number(updatedWorkCost.total);
            this.hideWorkCostForm();
            this.getSnackbarSuccess(this.languageData.calculationWorkCosts.updateWorkCostHead, this.languageData.calculationWorkCosts.updateWorkCostTextInfo);          
        })
    },
    beforeDestroy() {
        eventBus.$off('addNewWorkCost');
        eventBus.$off('updateWorkCost');
    }
}
</script>